<template>
  <div
    class="event-detail"
    @click.stop>
    <div class="event-detail__top">
      <div class="event-detail__heading">
        詳細
      </div>
      <div class="event-detail__created">
        <div class="event-detail__created-by">
          作成者 {{ event.createdBy.name }}
        </div>
        <div class="event-detail__created-at">
          更新日時 {{ event.updatedAt | dateTime }}
        </div>
      </div>
      <template v-if="isManager">
        <div class="d-flex flex-column actions">
          <div class="actions__wrapper top pb-2">
            <mini-button
              class="left"
              @click="toCopyPage">
              コピー
            </mini-button>
            <icon-button
              icon="edit"
              class="right"
              @click="toEditPage" />
          </div>
          <div class="actions__wrapper bottom">
            <event-stamp-dropdown
              class="left"
              :value="event.icon"
              @change="onSetStamp" />
            <span
              class="delete-icon material-icons right"
              @click="onDeleteEvent">
              delete
            </span>
          </div>
        </div>
      </template>
    </div>
    <div class="event-detail__middle">
      <!-- eslint-disable -->
      <div
        class="event-detail__detail"
        v-html="sanitizedLink(event.detail)" />
      <!-- eslint-enable -->
    </div>
    <file-viewer
      v-if="attachmentOption && event.file"
      class="mt-1"
      :file="event.file"
      :thumbnail="event.thumbnail"
      :filename="event.filename" />
    <div class="event-detail__bottom">
      <div class="d-flex justify-content-end align-items-center">
        <attendance-button
          type="attend"
          :active="isAttend"
          :count="event.attend"
          is-display-count
          @click="() => isAttend ? onCancelAttend() : onAttend()">
          参加
        </attendance-button>
        <text-button
          :active="isAttend"
          @click="openAttendUsersModal">
          +{{ event.attend }}
        </text-button>
        <attendance-button
          class="ml-2"
          type="absence"
          :active="isAbsence"
          :count="event.absence"
          is-display-count
          @click="() => isAbsence ? onCancelAttend() : onAbsence()">
          不参加
        </attendance-button>
        <text-button
          :active="isAbsence"
          @click="openAbsenceUsersModal">
          +{{ event.absence }}
        </text-button>
      </div>
    </div>
    <slot />
    <user-list-modal
      v-model="attendUserListModalVisible"
      :users="attendUsers"
      icon="person_add"
      title="参加する人"
      no-user-message="この予定にはまだ参加する人がいません" />
    <user-list-modal
      v-model="absenceUserListModalVisible"
      :users="absenceUsers"
      icon="person_remove"
      title="参加しない人"
      no-user-message="この予定にはまだ参加しない人がいません" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { format } from 'date-fns'
import IconButton from '@/components/parts/IconButton.vue'
import MiniButton from '@/components/parts/MiniButton.vue'
import FileViewer from '@/components/parts/FileViewer'
import AttendanceButton from '@/components/parts/AttendanceButton'
import TextButton from '@/components/parts/TextButton'
import UserListModal from '@/components/view/UserListModal.vue'
import sanitizedLinkMixin from '@/components/mixin/sanitizedLink'
import EventStampDropdown from '@/components/view/EventStampDropdown.vue'

export default {
  filters: {
    dateTime(v) {
      if (!v) return ''
      return format(new Date(v), 'yyyy/M/d HH:mm')
    }
  },
  components: {
    AttendanceButton,
    UserListModal,
    MiniButton,
    IconButton,
    TextButton,
    FileViewer,
    EventStampDropdown
  },
  mixins: [sanitizedLinkMixin],
  props: {
    event: {
      type: Object,
      required: true
    },
    isManager: {
      type: Boolean,
      required: true
    },
    onAttend: {
      type: Function,
      required: true
    },
    onAbsence: {
      type: Function,
      required: true
    },
    onCancelAttend: {
      type: Function,
      required: true
    },
    onSetStamp: {
      type: Function,
      required: true
    },
    onDeleteEvent: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      attendUsers: [],
      absenceUsers: [],
      attendUserListModalVisible: false,
      absenceUserListModalVisible: false,
    }
  },
  computed: {
    ...mapGetters('tenant', ['attachmentOption']),
    isAttend() {
      return !!this.event.myReply?.isAttend
    },
    isAbsence() {
      if (!this.event.myReply) {
        return false
      }
      return !this.event.myReply.isAttend
    },
  },
  methods: {
    toEditPage() {
      this.$router.push({ name: 'eventEdit', params: { id: this.event.id } })
    },
    toCopyPage() {
      this.$router.push({ name: 'eventAdd', query: { copy: this.event.id } })
    },
    openAttendUsersModal() {
      this.$axios.get(`/events/${this.event.id}/attend_users/`).then(res => {
        this.attendUsers = res.data.results
        this.attendUserListModalVisible = true
      }).catch(e => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    },
    openAbsenceUsersModal() {
      this.$axios.get(`/events/${this.event.id}/absence_users/`).then(res => {
        this.absenceUsers = res.data.results
        this.absenceUserListModalVisible = true
      }).catch(e => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.event-detail {
  border-top: 1px solid $grey10;
  padding: 4px 8px;

  &__heading {
    font-size: 14px;
    font-weight: 700;
    width: 42px;
    align-self: center;
  }

  &__created {
    align-self: center;
    flex-grow: 1;
    font-size: 12px;
    &-by {
      font-weight: 700;
    }
    &-at {
    }
  }

  &__top {
    padding-top: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .actions {
      &__wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.top {
          margin-bottom: 7px;
        }
        
        .left {
          width: 58px;
          display: block;
          margin-right: 10px;
        }

        .delete-icon {
          color: $primary;
          font-size: 30px;
          cursor: pointer;
        }
      }
    }
  }

  &__middle {
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  &__detail {
    color: $grey17;
    font-size: 16px;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: anywhere;
  }

  &__bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  &__attend-btn, &__absence-btn {
    padding: 4px;
    font-size: 14px;
    font-weight: 700;
  }

  &__attend-btn {
    color: $l-blue;
    margin-right: 8px;
  }
  &__absence-btn {
    color: $black;
  }
}
</style>